module.exports = "/_next/static/images/success-plus-graph-9435aa457491cd671c5aa7ba583b1f8e.png";